export default __webpack_public_path__ + "static/media/Cloud-Double.67e78a16.png";